import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { mapBrowserLanguageToSupported } from "./utils/languageDetection";
import { bindDocumentLanguage } from "./utils/documentLanguage";
import { bindDayjsLocale } from "./utils/dayjsLocale";

// Migrate legacy language codes in localStorage before i18n initialization
// This ensures users with old language codes (ger, dan) can load translations
if (typeof window !== "undefined" && window.localStorage) {
	try {
		const storedLang = localStorage.getItem("i18nextLng");
		if (storedLang) {
			const normalizedLang = mapBrowserLanguageToSupported(storedLang);
			if (normalizedLang !== storedLang) {
				localStorage.setItem("i18nextLng", normalizedLang);
				console.log(`[i18n] Migrated legacy language code: ${storedLang} -> ${normalizedLang}`);
			}
		}
	} catch (error) {
		console.error("[i18n] Error migrating language code:", error);
	}
}

function getDefaults() {
	return {
		order: [
			"querystring",
			"cookie",
			"localStorage",
			"sessionStorage",
			"navigator",
			"htmlTag",
		],
		lookupQuerystring: "lng",
		lookupCookie: "i18next",
		lookupLocalStorage: "i18nextLng",
		lookupSessionStorage: "i18nextLng",
		caches: ["localStorage"],
		excludeCacheFor: ["cimode"],
		// Custom language converter to map browser languages to supported codes
		convertDetectedLanguage: (lng) => {
			return mapBrowserLanguageToSupported(lng);
		},
	};
}

bindDocumentLanguage(i18n);
bindDayjsLocale(i18n);

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: "en",
		interpolation: {
			escapeValue: false, // react already safes from xss
		},
		detection: getDefaults(),
	});

export default i18n;
